import { useMeterType } from 'hooks/useMeterType';
import { usePartner } from 'components/app/routes/usePartner';
import { PARTNERS } from 'config/app-config';

export const useJourneyType = () => {
  const { activePartner } = usePartner();
  const { isBGECustomer } = useMeterType();

  const isNonDomesticTransferJourney =
    activePartner[PARTNERS.NONDOMESTIC_TRANSFER];

  switch (true) {
    case isNonDomesticTransferJourney:
      return 'business-to-residential';
    case isBGECustomer:
      return 'conversion';
    default:
      return 'acquisiton';
  }
};
